<template>
  <v-row no-gutters dense>
    <v-col v-for="(item, index) in itemsWithSubItems" :key="index" class="d-flex align-center" cols="auto">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" text :class="[
            $route.path.indexOf(item.route) !== -1 && 'menu-item-active',
            'mx-2'
          ]" v-if="
                lista_permissoes_filial.ra_Empresa == item.permissao ||
                lista_permissoes_filial.ra_funcionario == item.permissao ||
                lista_permissoes_filial.ra_Usuario == item.permissao ||
                lista_permissoes_filial.ra_FinanPedidosReceber == item.permissao ||
                lista_permissoes_filial.ra_Imovel == item.permissao ||
                lista_permissoes_filial.ra_Contrato == item.permissao ||
                lista_permissoes_filial.ra_FinanCaixa == item.permissao
              ">
            <v-icon left>{{ item.iconClass }}</v-icon>
            {{ item.title }}
            <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(subItem, subIndex) in item.subItems" :key="subIndex" :to="subItem.route" link :class="[
            $route.path.indexOf(subItem.route) !== -1 && 'menu-item-active'
          ]">
            <v-list-item-content>
              <v-list-item-title>{{ subItem.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>

    <v-col v-for="(item, index) in itemsWithoutSubItems" :key="'single-' + index" class="d-flex align-center"
      cols="auto">
      <v-btn :to="item.route" text :class="[
        $route.path.indexOf(item.route) !== -1 && 'menu-item-active',
        'mx-2'
      ]">
        <v-icon left>{{ item.iconClass }}</v-icon>
        {{ item.title }}
      </v-btn>
    </v-col>
  </v-row>

</template>

<script>
import sideMenu from "@/core/router/sideMenu";

export default {
  name: "KTMenu",

  data() {
    return {
      itemsMenu: sideMenu,
      sede_id: 1,
    };
  },
  created() {
    this.$store.dispatch("sistema/listar_filiais_autorizadas");
  },
  watch: {
    sede_id: function () {
      this.$store.dispatch("vincularSede", this.sede_id);
    },
  },
  computed: {
    lista_permissoes_filial() {
      return this.$store.state.sistema.lista_permissoes_filial;
    },
    lista_filiais_autorizadas() {
      return this.$store.state.sistema.lista_filiais_autorizadas;
    },
    itemsWithSubItems() {
      return this.itemsMenu.filter(item => item.subItems);
    },
    itemsWithoutSubItems() {
      return this.itemsMenu.filter(item => !item.subItems);
    },
  },
  methods: {
    hasActiveChildren(match) {
      return this.$route["path"].indexOf(match) !== -1;
    },
  },
};
</script>
